import { render, staticRenderFns } from "./navigate.vue?vue&type=template&id=20e2b9ea&"
import script from "./navigate.vue?vue&type=script&lang=js&"
export * from "./navigate.vue?vue&type=script&lang=js&"
import style0 from "./navigate.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("G:\\CompanyProject\\HF-IM-electron-workbench\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('20e2b9ea')) {
      api.createRecord('20e2b9ea', component.options)
    } else {
      api.reload('20e2b9ea', component.options)
    }
    module.hot.accept("./navigate.vue?vue&type=template&id=20e2b9ea&", function () {
      api.rerender('20e2b9ea', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/navigate.vue"
export default component.exports